
<script>

import { QTabs, QTab, QSeparator, QTabPanels, QTabPanel } from 'quasar'

export default {
  // functional: true,
  props: {
    data: Object,
    value: String,
    tabs: Array
  },
  render (createElement) { // props, data, children
    console.log(this.data)
    return createElement('div', {
      style: {
        border: '1px solid green',
        height: '100%'
      }
    },
    [
      createElement(QTabs, {
        props: Object.assign({
          align: 'justify',
          'inline-label': true,
          value: this.value
        }, this.data.titleStyle.props),
        attrs: this.data.titleStyle.attrs,
        on: Object.assign({
          input: (event) => {
            this.$emit('input', event)
          }
        }, this.data.titleStyle.on)
      },
      this.tabs.map(tab => {
        console.log(tab)
        return createElement(QTab, {
          props: Object.assign({ name: tab.name }, tab.title.props),
          attrs: { ...tab.title.attrs },
          on: tab.title.on
        })
      })
      ),
      createElement(QSeparator),
      createElement(QTabPanels, {
        props: Object.assign({ value: this.value }, this.data.contentStyle.props), //
        attrs: { ...this.data.contentStyle.attrs },
        on: this.data.contentStyle.on,
        style: { height: '100%' }
      },
      this.data.tabs.map(tab => createElement(QTabPanel, {
        props: Object.assign({ name: tab.name }, tab.content.props),
        attrs: { ...tab.content.attrs },
        on: tab.content.on
      }, this.$slots[tab.name])))
    ])
  }
}

</script>
<!--<template>
  <div class="tabContain">
    <q-tabs align='justify' inline-label v-bind:value="value" v-on:input="$emit('input', $event)">
      <q-tab v-for="tab in data.tabs" :key="tab.name" :name="tab.name" v-bind="tab.title.attrs"></q-tab>
    </q-tabs>
    <q-separator></q-separator>
    <q-tab-panels v-bind:value="value" class="tab-panel">
      <q-tab-panel v-for="tab in data.tabs" :key="tab.name" :name="tab.name">
        <slot :name="tab.name"></slot>
      </q-tab-panel>
    </q-tab-panels>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
    value:{
      type:String,
      default:''
    }
  },
  model:{
      event:'input',
      prop:'value'
  }
}
</script>-->
<style lang='scss'>
.tabContain {
  height: 100%;
  position: relative;
}
.tab {
  &-panel {
    height: 100%;
    position: relative;
  }
}
</style>
